export const initEducationItem = (educationItem = {}) => ({
    ...(educationItem || {}),
    institutionType: educationItem?.institutionType || null,
    institutionName: educationItem?.institutionName || null,
    institutionDist: educationItem?.institutionDist || null,
    attendingStatus: educationItem?.attendingStatus || null,
    attendingEndsAt: educationItem?.attendingEndsAt || null,
    attendingStartsAt: educationItem?.attendingStartsAt || null,
});

export const initWorkExperienceItem = () => ({
    // isRelevant: Boolean,
    type: null,
    companyName: null,
    description: null,
    duration: {
        startsAt: null,
        endsAt: null,
    },
});

export const initLanguageItem = (languageItem = {}) => ({
    ...(languageItem || {}),
    type: languageItem?.type || null,
    name: languageItem?.name || null,
    score: languageItem?.score || 0,
    tempId: Math.random(),
});

export const initOfficeSkillItem = (officeSkillItem = {}) => ({
    ...(officeSkillItem || {}),
    type: officeSkillItem?.type || null,
    name: officeSkillItem?.name || null,
    score: officeSkillItem?.score || 0,
    tempId: Math.random(),
});

export const initCertificationItem = (certificationItem = {}) => ({
    ...(certificationItem || {}),
    name: certificationItem?.name || null,
    desc: certificationItem?.desc || null,
    issuer: certificationItem?.issuer || null,
    issuedAt: certificationItem?.issuedAt || null,
    tempId: Math.random(),
});

export const initResume = (resume = {}) => ({
    ...resume,

    name: resume?.name || null,
    profile: resume?.profile || null,

    personalInformation: {
        ...(resume?.personalInformation || {}),

        name: resume?.personalInformation?.name || null,
        phone: resume?.personalInformation?.phone || null,
        email: resume?.personalInformation?.email || null,
        gender: resume?.personalInformation?.gender || null,
        bornAt: resume?.personalInformation?.bornAt || null,

        residence: {
            ...(resume?.personalInformation?.residence || {}),

            postcode: resume?.personalInformation?.residence?.postcode || null,
            address1: resume?.personalInformation?.residence?.address1 || null,
            address2: resume?.personalInformation?.residence?.address2 || null,
        },
    },

    education: {
        ...initEducationItem(resume?.education),
        otherEducations: resume?.education?.otherEducations || [],
    },

    workExperience: {
        ...(resume?.workExperience || {}),
        type: resume?.workExperience?.type || null,
        span: {
            ...(resume?.workExperience?.span || {}),
            years: resume?.workExperience?.span?.years || null,
            months: resume?.workExperience?.span?.months || null,
        },
        list: resume?.workExperience?.list || [],
    },

    languages: [...(resume?.languages || [])].map(initLanguageItem),

    officeSkills: [...(resume?.officeSkills || [])].map(initOfficeSkillItem),

    certifications: [...(resume?.certifications || [])].map(initCertificationItem),

    coverLetter: {
        ...(resume?.coverLetter || {}),
        subject: resume?.coverLetter?.subject || null,
        content: resume?.coverLetter?.content || null,
    },
});
